<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <h2>当前管理员</h2>
      <p>财务系统只允许当前公司的管理员操作</p>
    </div>
    <el-card
      v-loading="loading"
      shadow="never"
    >
      <el-descriptions
        v-if="data.user"
        :column="2"
        border
      >
        <el-descriptions-item label="账号">
          {{ data.user.account }}
        </el-descriptions-item>
        <el-descriptions-item label="姓名">
          {{ data.user.name }}
        </el-descriptions-item>
        <el-descriptions-item label="手机">
          {{ data.user.phone || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="邮箱">
          {{ data.user.email || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="公司">
          {{ data.unit?.name || data.user.unit_id }}
        </el-descriptions-item>
        <el-descriptions-item label="权限">财务管理员</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { organizationApi } from '../api'
const data = ref({}),
  loading = ref(false)
onMounted(async () => {
  loading.value = true
  try {
    data.value = (await organizationApi.profile()) || {}
  } finally {
    loading.value = false
  }
})
</script>
<style scoped>
.page-head {
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
